export const sideNavCollapsedWidth = 59;

export const sideNavCollapsedWidthSmallScreen = 0;

export const sideNavExpandedWidth = 224;

export const topNavHeight = 50;

export const appFrameGutterLeft = 20;

export const appFrameInset = 12;

export const appShellBorderWidth = 1;

export const appShellBorderRadius = 12;

export const sideNavTopOffset = 6;

export const TOP_LEVEL_NAV_OPTIONS = {
    AGENT_TOOLKIT: 'agent-toolkit',
    ANALYTICS: 'analytics',
    ANALYTICS_UPSELL: 'analytics-upsell',
    DASHBOARDS: 'dashboards',
    GUIDES: 'guides',
    GUIDES_UPSELL: 'guides-upsell',
    GUIDES_PRO_UPSELL: 'guides-pro-upsell',
    SALESFORCE_UPSELL: 'salesforce-upsell',
    HOME: 'home',
    LISTEN: 'listen',
    LISTEN_UPSELL: 'listen-upsell',
    NPS: 'nps',
    NPS_UPSELL: 'nps-upsell',
    ORCHESTRATE: 'orchestrate',
    ORCHESTRATE_UPSELL: 'orchestrate-upsell',
    PENDO_TOOLS: 'pendo-tools',
    PEOPLE: 'people',
    PREDICT: 'predict',
    PRODUCT: 'product',
    REPLAY: 'replay',
    REPLAY_UPSELL: 'replay-upsell',
    ROADMAPS: 'roadmaps',
    SURVEYS: 'sentiment',
    SURVEYS_UPSELL: 'surveys-upsell',
    SPACES: 'spaces',
    SETTINGS: 'settings',
    PREDICT_UPSELL: 'predict-upsell',
};

export const SECONDARY_LEVEL_NAV_OPTIONS = {
    ACCOUNTS: 'accounts',
    AI_AGENTS: 'agent-analytics',
    APPS: 'apps',
    APPLICATION_USAGE: 'application-usage',
    EMAILS: 'emails',
    EMPLOYEE_LICENSE_UTILIZATION: 'employee-license-utilization',
    EXPERIMENTS: 'experiments',
    EXPLORE_FEEDBACK: 'explore-feedback',
    FEATURE_FLAGS: 'feature-flags',
    FEATURES: 'features',
    FEEDBACK_SOURCES: 'feedback-sources',
    FORM_VALIDATION: 'form-validation',
    GUIDES: 'guides',
    INSIGHTS: 'insights',
    JOURNEYS: 'journeys',
    LISTEN_AUTOMATION: 'listen-automation',
    LISTEN_FEEDBACK: 'listen-feedback',
    LISTEN_GETTING_STARTED: 'listen-getting-started',
    LISTEN_PORTAL: 'listen-portal',
    LISTEN_SETTINGS: 'listen-settings',
    LIVE_REPLAYS: 'live-replays',
    OBJECT_ANALYTICS: 'object-analytics',
    PAGES: 'pages',
    PES: 'pes',
    PORTFOLIO: 'portfolio',
    PORTFOLIO_INSIGHTS: 'portfolio-insights',
    PREDICT: 'predict',
    PRODUCT_AREAS: 'product-areas',
    RESOURCE_CENTER: 'resource-center',
    REPLAY_LIBRARY: 'replay-library',
    REPORTS: 'reports',
    SAVED_CLIPS: 'saved-clips',
    SEGMENTS: 'segments',
    TRACK_EVENTS: 'track-events',
    VALIDATE_IDEAS: 'validate-ideas',
    VISITORS: 'visitors',
    WEB_ANALYTICS: 'web-analytics',
};

export const EXPANDED_NAV_LS_KEY = 'expanded-left-nav';
